"use client"

import { usePathname } from "next/navigation"

import { FluidFooter } from "./fluid-footer"

export function SiteFooter() {
  const pathname = usePathname()
  const isPolicyPage = ["/privacy-policy", "/terms-of-service", "/cookie-policy"].includes(pathname)

  if (isPolicyPage) {
    return null
  }

  const isChatPage = pathname === "/chat"
  if (isChatPage) {
    return null
  }

  return <FluidFooter />
}

